module.exports = __webpack_public_path__ + "static/img/park1 (3).04263680.jpg";